export const availableCurrency = [
    {id: 1, name: 'PLN', flagCode: 'PL', isPrefered: true},
    {id: 2, name: 'EUR', flagCode: 'EU', isPrefered: true},
    {id: 3, name: 'GBP', flagCode: 'GB', isPrefered: true},
    {id: 4, name: 'CHF', flagCode: 'CH'},
    {id: 5, name: 'RON', flagCode: 'RO'},
    {id: 6, name: 'BGN', flagCode: 'BG'},
    {id: 9, name: 'HUF', flagCode: 'HU'},
    {id: 10, name: 'SEK', flagCode: 'SE'},
    {id: 11, name: 'CZK', flagCode: 'CZ'},
    {id: 12, name: 'USD', flagCode: 'US'},
    {id: 14, name: 'AUD', flagCode: 'AU'},
    {id: 15, name: 'NOK', flagCode: 'NO'},
    {id: 16, name: 'DKK', flagCode: 'DK'},
    {id: 17, name: 'UAH', flagCode: 'UA'},
    {id: 18, name: 'RUB', flagCode: 'RU'},
    {id: 19, name: 'BYN', flagCode: 'BY'},
    {id: 20, name: 'AZN', flagCode: 'AZ'},
    {id: 21, name: 'KGS', flagCode: 'KG'},
    {id: 22, name: 'TJS', flagCode: 'TJ'},
    {id: 23, name: 'UZS', flagCode: 'UZ'},
    {id: 23, name: 'AMD', flagCode: 'AM'},
    {id: 24, name: 'MDL', flagCode: 'MD'},
    {id: 25, name: 'GEL', flagCode: 'GE'},
    {id: 26, name: 'KZT', flagCode: 'KZ'},
    {id: 27, name: 'TMT', flagCode: 'TM'},
];

export const availableCountries = [
    {code: 'GB', name: 'United Kingdom', currency: 'GBP', suggested: true, order: 1},
    {code: 'PL', name: 'Poland', currency: 'PLN', suggested: true, order: 2},
    {code: 'UA', name: 'Ukraine', currency: 'UAH', suggested: true, order: 3},
    {code: 'IE', name: 'Ireland', currency: 'EUR', suggested: true, order: 4},
    {code: 'AT', name: 'Austria', currency: 'EUR'},
    {code: 'CY', name: 'Cyprus', currency: 'EUR'},
    {code: 'MT', name: 'Malta', currency: 'EUR'},
    {code: 'IT', name: 'Italy', currency: 'EUR'},
    {code: 'BE', name: 'Belgium', currency: 'EUR'},
    {code: 'DK', name: 'Denmark', currency: 'DKK'},
    {code: 'EE', name: 'Estonia', currency: 'EUR'},
    {code: 'FI', name: 'Finland', currency: 'EUR'},
    {code: 'FR', name: 'France', currency: 'EUR'},
    {code: 'GR', name: 'Greece', currency: 'EUR'},
    {code: 'ES', name: 'Spain', currency: 'EUR'},
    {code: 'NL', name: 'Netherlands', currency: 'EUR'},
    {code: 'LT', name: 'Lithuania', currency: 'EUR'},
    {code: 'LU', name: 'Luxembourg', currency: 'EUR'},
    {code: 'LV', name: 'Latvia', currency: 'EUR'},
    {code: 'DE', name: 'Germany', currency: 'EUR'},
    {code: 'PT', name: 'Portugal', currency: 'EUR'},
    {code: 'SK', name: 'Slovakia', currency: 'EUR'},
    {code: 'SI', name: 'Slovenia', currency: 'EUR'},
    {code: 'HR', name: 'Croatia', currency: 'EUR'},
    {code: 'CH', name: 'Switzerland', currency: 'CHF'},
    {code: 'RO', name: 'Romania', currency: 'RON'},
    {code: 'BG', name: 'Bulgaria', currency: 'BGN'},
    {code: 'HU', name: 'Hungary', currency: 'HUF'},
    {code: 'SE', name: 'Sweden', currency: 'SEK'},
    {code: 'CZ', name: 'Czech Republic', currency: 'CZK'},
    {code: 'NO', name: 'Norway', currency: 'NOK'},
    {code: 'LI', name: 'Liechtenstein', currency: 'EUR'},
    {code: 'IS', name: 'Iceland', currency: 'USD'},
    {code: 'AM', name: 'Armenia', currency: 'USD'},
    {code: 'KZ', name: 'Kazakhstan', currency: 'USD'},
    {code: 'UZ', name: 'Uzbekistan', currency: 'USD'},
    {code: 'MD', name: 'Moldavia', currency: 'USD'},
    {code: 'GE', name: 'Georgia', currency: 'USD'},
    {code: 'RU', name: 'Rosja', currency: 'RUB'},
    {code: 'BY', name: 'Białoruś', currency: 'BYN'},
    {code: 'AZ', name: 'Azerbejdżan', currency: 'AZN'},
    {code: 'KG', name: 'Kirgistan', currency: 'KGS'},
    {code: 'TJ', name: 'Tadżykistan', currency: 'TJS'},
    {code: 'TM', name: 'Turkmenistan', currency: 'TMT'},
];
